import EzUser, { IUserData } from 'lib/user-data';

const ezUser:IUserData = new EzUser();

ezUser.init();

export default ezUser;
